<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {

  },
  data() {
    return {
      title: "Donasi yang dapat anda wujudkan...",
      items: [
        {
          text: "Dashboards",
          href: "/"
        },
      ],
    };
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
  <nav class="navbar navbar-expand-lg navigation sticky" id="navbar">
    <div class="container">
      <a class="navbar-logo" href="/">
        <img src="@/assets/images/gurukreator.png" alt="paideia education solution" height="40" margin-top="10" class="logo logo-dark" />
        <img src="@/assets/images/gurukreator.png" alt="paideia education solution" height="40" margin-top="10" class="logo logo-light" />
      </a>
    </div>
  </nav>

  <div class="text-center mt-5">
    <b-button-group style="width:280px;">
            <b-button class="mb-5 mr-1" style="background-color: #00AFEF; border-style:none;" variant="primary rounded-pill">Pribadi</b-button> 
            <b-button class="mb-5 ml-1" style="background-color: #00AFEF; border-style:none" variant="primary rounded-pill">Donatur</b-button> 
    </b-button-group>
  </div>

    <div class="row">
      <div class="col-xl-4">
        <div class="card"
              style= "
                      border-radius: 8px;
                      box-shadow: 1px 2px 8px rgba(0, 0, 0, 0.10);
                      margin: 0rem 1rem 1rem 1rem;
                      height: 200px;
                    "   
        >
          <div class="card-body">
            <h5 style="margin-left:10px; color:#373334"><img class="mt-3 mr-4" src="@/assets/images/domba.png" alt="" width="60px" height="60px" style="float:left">Domba (Sheep)</h5>
            <p style="color:#707070">3 Guru Kreator</p>
            <p style="color:#c6c6c6"><span class="blue-paideia"><b>Rp 50.000</b></span> / bulan</p>
          </div>
            <b-button class="mb-3 ml-5 mr-5" style="background-color: #00AFEF; border-style:none" variant="primary rounded-pill">Berlangganan Sekarang</b-button> 
        </div>
      </div>
      <!-- end col -->
      <div class="col-xl-4">
        <div class="card"
              style= "
                      border-radius: 8px;
                      box-shadow: 1px 2px 8px rgba(0, 0, 0, 0.10);
                      margin: 0rem 1rem 1rem 1rem;
                      height: 200px;
                    "   
        >
          <div class="card-body">
            <h5 style="margin-left:10px; color:#373334"><img class="mt-3 mr-4" src="@/assets/images/kancil.png" alt="" width="60px" height="60px" style="float:left">Kancil (Mouse Deer)</h5>
            <p style="color:#707070">5 Guru Kreator</p>
            <p style="color:#c6c6c6"><span class="blue-paideia"><b>Rp 84.000</b></span> / bulan</p>
          </div>
            <b-button class="mb-3 ml-5 mr-5" style="background-color: #00AFEF; border-style:none" variant="primary rounded-pill">Berlangganan Sekarang</b-button> 
        </div>
      </div>
      <!-- end col -->
      <div class="col-xl-4">
        <div class="card"
              style= "
                      border-radius: 8px;
                      box-shadow: 1px 2px 8px rgba(0, 0, 0, 0.10);
                      margin: 0rem 1rem 1rem 1rem;
                      height: 200px;
                    "   
        >
          <div class="card-body">
            <h5 style="margin-left:10px; color:#373334"><img class="mt-3 mr-4" src="@/assets/images/rusa.png" alt="" width="60px" height="60px" style="float:left">Kijang (Deer)</h5>
            <p style="color:#707070">10 Guru Kreator</p>
            <p style="color:#c6c6c6"><span class="blue-paideia"><b>Rp 167.000</b></span> / bulan</p>
          </div>
            <b-button class="mb-3 ml-5 mr-5" style="background-color: #00AFEF; border-style:none" variant="primary rounded-pill">Berlangganan Sekarang</b-button> 
        </div>
        </div>
      </div>
      <!-- end col -->



    <div class="row">
      <div class="col-xl-4">
        <div class="card"
              style= "
                      border-radius: 8px;
                      box-shadow: 1px 2px 8px rgba(0, 0, 0, 0.10);
                      margin: 0rem 1rem 1rem 1rem;
                      height: 200px;
                    "   
        >
          <div class="card-body">
            <h5 style="margin-left:10px; color:#373334"><img class="mt-4 mr-4" src="@/assets/images/macan.png" alt="" width="60px" height="40px" style="float:left;">Macan (Tiger)</h5>
            <p style="color:#707070">100 Guru Kreator</p>
            <p style="color:#c6c6c6"><span class="blue-paideia"><b>Rp 1.67jt</b></span> / bulan</p>
          </div>
            <b-button class="mb-3 ml-5 mr-5" style="background-color: #00AFEF; border-style:none" variant="primary rounded-pill">Berlangganan Sekarang</b-button> 
        </div>
      </div>
      <!-- end col -->
      <div class="col-xl-4">
        <div class="card"
              style= "
                      border-radius: 8px;
                      box-shadow: 1px 2px 8px rgba(0, 0, 0, 0.10);
                      margin: 0rem 1rem 1rem 1rem;
                      height: 200px;
                    "   
        >
          <div class="card-body">
            <h5 style="margin-left:10px; color:#373334"><img class="mt-4 mb-2 mr-4" src="@/assets/images/badak.png" alt="" width="60px" height="35px" style="float:left">Badak (Rhino)</h5>
            <p style="color:#707070">250 Guru Kreator</p>
            <p style="color:#c6c6c6"><span class="blue-paideia"><b>Rp 4.17jt</b></span> / bulan</p>
          </div>
            <b-button class="mb-3 ml-5 mr-5" style="background-color: #00AFEF; border-style:none" variant="primary rounded-pill">Berlangganan Sekarang</b-button> 
        </div>
      </div>
      <!-- end col -->
      <div class="col-xl-4">
        <div class="card"
              style= "
                      border-radius: 8px;
                      box-shadow: 1px 2px 8px rgba(0, 0, 0, 0.10);
                      margin: 0rem 1rem 1rem 1rem;
                      height: 200px;
                    "   
        >
          <div class="card-body">
            <h5 style="margin-left:10px; color:#373334"><img class="mt-4 mr-4" src="@/assets/images/gajah.png" alt="" width="60px" height="45px" style="float:left">Gajah (Elephant)</h5>
            <p style="color:#707070">500 Guru Kreator</p>
            <p style="color:#c6c6c6"><span class="blue-paideia"><b>Rp 8.3jt</b></span> / bulan</p>
          </div>
            <b-button class="mb-3 ml-5 mr-5" style="background-color: #00AFEF; border-style:none" variant="primary rounded-pill">Berlangganan Sekarang</b-button> 
        </div>
        </div>
      </div>

    <div class="row">
      <div class="col-xl-4">
        <div class="card"
              style= "
                      border-radius: 8px;
                      box-shadow: 1px 2px 8px rgba(0, 0, 0, 0.10);
                      margin: 0rem 1rem 1rem 1rem;
                      height: 200px;
                    "   
        >
          <div class="card-body mb-3">
            <h5 style="margin-left:10px; color:#373334"><img class="mt-4 mr-4" src="@/assets/images/komodo.png" alt="" width="60px" height="50px" style="float:left">Komodo (Dragons)</h5>
            <p style="color:#707070">1000 Guru Kreator</p>
            <p style="color:#c6c6c6"><span class="blue-paideia"><b>Rp 16.7jt</b></span> / bulan</p>
            <p class="blue-paideia" style="margin-top:0px; margin-left:90px; margin-bottom:100px;"><img src="@/assets/images/star.png" width="20px" height="20px" style="margin-bottom:5px;">Recommended</p>
          </div>
            <b-button class="mb-3 ml-5 mr-5" style="background-color: #00AFEF; border-style:none" variant="primary rounded-pill">Berlangganan Sekarang</b-button> 
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

    
  </Layout>
</template>
